import { AbstractModel, DateUtil, DocumentTypeConstants, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { DocumentField } from './document-field';

@inheritSerialization(AbstractModel)
export class DocumentType extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  description: string;

  @autoserialize
  vehicleRequired: boolean;

  @autoserialize
  requiresExpirationDate: boolean;

  @autoserialize
  requiresNumber: boolean;

  @autoserialize
  requiresState: boolean;

  @autoserializeAs(DocumentField)
  documentFields: Array<DocumentField>;

  @autoserialize
  numberPlaceholder: string;

  @autoserializeAs(Date)
  requiredByDate: Date;

  static OnSerialized(instance: DocumentType, json: any): void {
    if (!isNullOrUndefined(instance.requiredByDate)) {
      json.requiredByDate = DateUtil.serializeLocalDate(instance.requiredByDate);
    }
  }

  static OnDeserialized(instance: DocumentType, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['requiredByDate'])) {
      instance.requiredByDate = DateUtil.deserializeLocalDate(json['requiredByDate']);
    }
  }

  getDocumentNumberLabel(): string {
    switch (this.name) {
      case DocumentTypeConstants.DRIVERS_LICENSE:
        return "Driver's License Number";
      case DocumentTypeConstants.AUTOMOBILE_INSURANCE:
        return 'Policy Number';
      case DocumentTypeConstants.VEHICLE_INSPECTION_CERTIFICATE:
        return 'Inspection Number';
      default:
        return 'Document Number';
    }
  }
}
